/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable lingui/text-restrictions */

//import { DEFAULT_MAX_TOKENS, DEFAULT_MODEL } from "@/client/constants/llm";
//import { useOpenAiStore } from "@/client/stores/openai";
import { openai } from "./client";

const SYSTEM_PROMPT = `你是一位专门负责简历语法纠错的AI助手。你的任务是纠正文本中的语法错误，同时严格保持原有的专业内容。

【纠错重点】
1. 语法检查
<ul>
<li>修正不规范的句式</li>
<li>纠正标点符号使用错误</li>
<li>确保时态统一</li>
<li>修正语序问题</li>
</ul>

2. 格式规范
<ul>
<li>统一日期格式（如：2020年-2022年）</li>
<li>统一数字格式（如：增长30%）</li>
<li>规范化缩写使用</li>
</ul>

【严格保持不变的内容】
<ul>
<li>专业技术术语（如：React.js、Vue.js、Docker等）</li>
<li>公司名称和产品名称</li>
<li>具体的数据指标</li>
<li>项目名称</li>
<li>职位名称</li>
</ul>

【输出格式要求】
1. 必须使用HTML标签
<ul>
<li>段落使用 <p> 标签</li>
<li>换行使用 <br> 标签</li>
<li>列表使用 <ul> 和 <li> 标签</li>
</ul>

2. 示例格式：
<p>XX公司 (2020-2022)</p>
<ul>
<li>负责 A 项目的开发与维护</li>
<li>使用 React.js 开发前端功能</li>
</ul>`;

const USER_PROMPT = `请仅对语法和格式进行修正，保持原意不变，直接返回修改后的文本。不要添加任何解释或建议。

原文: {input}`;

export const fixGrammar = async (text: string) => {
  const result = await openai().chat.completions.create({
    messages: [
      { role: "system", content: SYSTEM_PROMPT },
      { role: "user", content: USER_PROMPT.replace("{input}", text) },
    ],
    model: "glm-4-flash",
    max_tokens: 2048,
    temperature: 0,
    n: 1,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI 没有返回任何内容。`);
  }

  let content = result.choices[0].message.content ?? text;

  // Remove code block markers if present
  if (content.includes("```")) {
    const matches = /```(?:html)?\s*([\S\s]*?)\s*```/.exec(content);
    content = matches?.[1] ?? content;
  }

  return content.trim();
};
